import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accessoire-form"
}
const _hoisted_2 = { class: "accessoire-col" }
const _hoisted_3 = { class: "col-center" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

import QuantitySelector from './QuantitySelector.vue';
import { ChoosenAccessoire, DEFAULT_PRODUCT, IProduct, ID_ROULEAU, ID_VIS } from '@/model/Product';
import { DigInputSelectPicker } from '@digithia/input/select';
import { computed, Ref, ref } from '@vue/reactivity';
import { PropType, watch } from 'vue'

interface AccForm { quantity: number, amount: number, couleur: string }


export default /*#__PURE__*/_defineComponent({
  props: {
  accessoires: { type: Array as PropType<IProduct[]>, default: () => [] },
  accessoire: { type: Object as PropType<IProduct | undefined>, default: () => undefined },
  lame: { type: Object as PropType<IProduct | undefined>, default: () => undefined },
},
  emits: ['update', 'updateInfo'],
  setup(__props, { emit: emits }) {

const props = __props

const choosenAccessoire: ChoosenAccessoire = { product: DEFAULT_PRODUCT, quantity: 0, amount: 0 }
const form: Ref<AccForm> = ref({ quantity: 0, amount: 0, couleur: '' })



const currentCouleurs = computed(() => {
  return props.accessoires
    .filter(p => p.description_base === props.accessoire?.description_base && p.couleur)
    .map(p => p.couleur)
    .filter(c => !c.match('COL_'))
})

const isShown = computed(() => {
  if (props.accessoire?.ref_unique === 'BAR_UD_95') {
    return !props.lame || props.lame?.categorie === 'cv' && props.lame?.hauteur_utile_mm === '95'
  }
  if (props.accessoire?.ref_unique === 'BAR_UD_150_195_200') {
    return !props.lame || props.lame?.hauteur_utile_mm !== '95'
  }
  if (props.accessoire?.ref_unique === 'BAR_CONNECTEUR_95') {
    return !props.lame || props.lame?.categorie === 'cv' && props.lame?.hauteur_utile_mm === '95'
  }
  if (props.accessoire?.ref_unique === 'BAR_CONNECTEUR_195') {
    return !props.lame || props.lame?.categorie === 'cl' && (props.lame?.hauteur_utile_mm === '195' || props.lame?.hauteur_utile_mm === '200')
  }
  if (props.accessoire?.ref_unique === 'BAR_JONC_95') {
    return !props.lame || props.lame?.categorie === 'cv' && props.lame?.hauteur_utile_mm === '95'
  }
  if (props.accessoire?.ref_unique === 'BAR_JONC_150') {
    return !props.lame || props.lame?.categorie === 'cl' && props.lame?.hauteur_utile_mm === '150'
  }
  if (props.accessoire?.ref_unique === 'BAR_JONC_195-200') {
    return !props.lame || props.lame?.hauteur_utile_mm === '195' || props.lame?.hauteur_utile_mm === '200'
  }

  return true
})



const updateAccessoireForm = (key: keyof AccForm, value: any) => {
  form.value[key] = value as never

  choosenAccessoire.quantity = Math.ceil(form.value.quantity)
  choosenAccessoire.amount = Math.ceil(form.value.amount)

  const acc = props.accessoires
    .find(a => a.idp === choosenAccessoire.product.idp && a.couleur === form.value.couleur)

  if (acc) {
    choosenAccessoire.product = acc
  } else if (props.accessoire) {
    choosenAccessoire.product = props.accessoire
  }

  emits('update', { ...choosenAccessoire })
}

const updateInfo = () => {
  emits('updateInfo', props.accessoire)
}

watch(() => props.lame, () => {
  if (!props.lame?.couleur) return
  updateAccessoireForm('couleur', props.lame?.couleur)
})


return (_ctx: any,_cache: any) => {
  return (_unref(isShown))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(QuantitySelector, {
              input: form.value.quantity,
              accessoire: __props.accessoire,
              onUpdateQuantity: _cache[0] || (_cache[0] = ($event: any) => (updateAccessoireForm('quantity', $event))),
              onUpdateAmount: _cache[1] || (_cache[1] = ($event: any) => (updateAccessoireForm('amount', $event)))
            }, null, 8, ["input", "accessoire"])
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(__props.accessoire?.titre_base) + " ", 1),
            (__props.accessoire?.idp === _unref(ID_ROULEAU) || __props.accessoire?.idp === _unref(ID_VIS) && __props.accessoire?.titre_dec)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(__props.accessoire?.titre_dec) + ") ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "info-bulle",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (updateInfo()))
            }, " i ")
          ]),
          (_unref(currentCouleurs).length > 1)
            ? (_openBlock(), _createElementBlock("dig-input-select-picker", {
                key: 0,
                class: "select-couleur",
                value: form.value.couleur,
                label: "Couleur",
                required: "",
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (updateAccessoireForm('couleur', $event.detail)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentCouleurs), (COULEUR) => {
                  return (_openBlock(), _createElementBlock("dig-input-select-picker-option", {
                    key: COULEUR,
                    value: COULEUR
                  }, _toDisplayString(COULEUR), 9, _hoisted_7))
                }), 128))
              ], 40, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})